$(function () {

    if(!document.querySelector('#login-dialog')){
        return;
    }

    var loginDialog = {
        dialogBoxDom: document.querySelector('#login-dialog'),
        maskDom: document.querySelector('#login-dialog').querySelector('.mask'),
        dialogDom: document.querySelector('#login-dialog').querySelector('.login-container'),
        vueObject: null,
        memberType: 'ACQ会员', // 登录的会员类型
        needLottery: true, // 是否有抽奖
        applyTip: '',
        initialPassword: '336633',

        vueExp: function () {
            //axios 配置
            axios.defaults.crossDomain = true;
            axios.defaults.headers.post['Content-Type'] = 'text/plain; charset=utf-8';
            axios.defaults.baseURL = window.smk_api_host + '/';
            var dialogObj = this;
            this.vueObject = new Vue({
                el: "#vue-login-dialog",
                data: {
                    isDialogShow: true,
                    dialogStatus: 'regist',
                    isAcqMember: false,
                    sess: '',
                    purchaseIntentionForm: {
                        formName:"申请会员",
                        formDesc: '填写您的个人信息，提交成功后您的客户经理会与您联系，请您保持手机畅通',
                        formId:12918,
                        customFilds:{
                            productName:'custom_form_field_1566885090184',
                            productId:'custom_form_field_1566885102334',
                            productPrice:'custom_form_field_1566885114805',
                            productNum:'custom_form_field_1566885123251',
                            linkSourceModule: 'custom_form_field_1566885262493',
                            pagetitle: 'custom_form_field_1568974162907',
                            pageurl: 'custom_form_field_1569377391873' //取当前页面URL（暂时不用）
                        },
                        referenceUrl: 'ACQ贵宾会员',
                        behaviorType:"提交产品采购单",
                        gioType:'buysubmit_product'
                    },

                    // 注册表单
                    // 重设密码
                    registForm: {
                        title: '注册',
                        //手机号 验证码 密码 重复密码
                        formList: {
                            userName: {
                                lebal: '手机号',
                                placeholder: '请输入您的手机号',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '手机号输入错误',
                                errorTextEmpty: '请输入您的手机号',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_addTol');
                                }
                            },
                            verifyCode: {
                                lebal: '验证码',
                                placeholder: '请输入验证码',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: /^\d{6}$/,
                                errorText: '',
                                errorTextContent: '你输入的验证码不正确',
                                errorTextEmpty: '请输入验证码',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_addCode');
                                }
                            },
                            password: {
                                lebal: '密码',
                                placeholder: '请输入您的密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: /^[A-Za-z0-9]{8,50}$/,
                                errorText: '',
                                errorTextContent: '密码长度需大于8位',
                                errorTextEmpty: '请输入您的密码',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_addPassword');
                                }
                            },
                            rePassword: {
                                lebal: '确认密码',
                                placeholder: '请再次输入密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '您输入的两次密码不一致',
                                errorTextEmpty: '请再次输入密码',
                                focusAction: function () {
                                    gioTrackAction.gio_base('individualRegister_confirmPassword');
                                }
                            },
                            ifWish: {
                                lebal: '为了方便您了解戴尔更多解决方案、产品，您是否愿意接受戴尔科技销售/合作伙伴与您联系吗？',
                                placeholder: '',
                                value: '',
                                type: 'radio',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '请选择',
                                errorTextEmpty: '请选择'
                            },
                        },
                        subBtnText: '注册',
                        subBtnDisabled: false,
                        isShowTextBtn: true,
                        textBtnText: '已有账号？去登录'
                    },

                    // 登录表单
                    loginForm: {
                        title: '企采会员请登录',
                        formList: {
                            userName: {
                                lebal: '会员账号',
                                placeholder: '请输入您的会员账号',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '会员账号输入错误',
                                errorTextEmpty: '请输入您的会员账号',
                            },
                            password: {
                                lebal: '会员密码',
                                placeholder: '请输入您的密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '会员密码输入错误',
                                errorTextEmpty: '请输入您的会员密码',
                            }
                        },
                        subBtnText: '登录',
                        subBtnDisabled: false,

                        registerBtnText: '申请会员',
                        registerBtnDisabled: false,

                        isShowTextBtn: true,
                        textBtnText: '忘记密码'
                    },

                    // 重设密码
                    resetPasswordForm: {
                        title: '您的密码为初始密码<br>为了保障您的账号安全请重置您的密码',
                        formList: {
                            password: {
                                lebal: '输入新密码',
                                placeholder: '请输入您的新会员密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: /^[A-Za-z0-9]{8,50}$/,
                                errorText: '',
                                errorTextContent: '密码长度需大于8位',
                                errorTextEmpty: '请输入您的新会员密码',
                            },
                            rePassword: {
                                lebal: '确认新密码',
                                placeholder: '请再次输入新会员密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '您输入的两次密码不一致',
                                errorTextEmpty: '请再次输入新会员密码',
                            }
                        },
                        subBtnText: '确定',
                        subBtnDisabled: false,
                        isShowTextBtn: false,
                        textBtnText: '忘记密码'
                    },
                    // 重设密码
                    forgetPasswordForm: {
                        title: '忘记密码',
                        formList: {

                            userName: {
                                lebal: '会员账号',
                                placeholder: '请输入您的会员账号',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '会员账号输入错误',
                                errorTextEmpty: '请输入您的会员账号',
                            },
                            verifyCode: {
                                lebal: '验证码',
                                placeholder: '请输入验证码',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: /^\d{6}$/,
                                errorText: '',
                                errorTextContent: '你输入的验证码不正确',
                                errorTextEmpty: '请输入验证码',
                            },
                            password: {
                                lebal: '输入新密码',
                                placeholder: '请输入您的新会员密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: /^[A-Za-z0-9]{8,50}$/,
                                errorText: '',
                                errorTextContent: '密码长度需大于8位',
                                errorTextEmpty: '请输入您的新会员密码',
                            },
                            rePassword: {
                                lebal: '确认新密码',
                                placeholder: '请再次输入新会员密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '您输入的两次密码不一致',
                                errorTextEmpty: '请再次输入新会员密码',
                            }
                        },
                        subBtnText: '确定',
                        subBtnDisabled: false,
                        isShowTextBtn: true,
                        textBtnText: '验证会员身份'
                    },


                    form: {
                        title: ''
                    },

                    //验证码发送倒计时
                    sendCode: {
                        time: 60,
                        isSending: false,
                        isTimer: false,
                        text: ""
                    },
                    list: [],
                    keyword: '',
                    userInfo: {},
                    iframeLink: '', //授权链接
                    authorizationLnk: 'https://www.dell.com/dci/fp/authorize/faa1f369-d81a-4ccb-ab23-5d22311cda4e?Id=98aa5b3d-af4a-4c86-9a1f-449560e1593b',
                    // api: {
                    //     getUserInfo: '',
                    //     login: '',
                    //     changePassword: '',
                    //     reSetPassword: ''
                    // }
                    loginTimeout:null
                },
                created: function () {
                    this.form = this.registForm;
                    // this.getUserInfo();
                    // dialogObj.hideLoading();
                    console.log(this.form);
                },
                methods: {
                    setApplyTip: function(){
                        // 在意向单内插入提示文字
                        $('.m-dialog-box .m-bargain-body .dialog-body-tips,.dialog-box .dialog-content .dialog-body-tips').html(dialogObj.applyTip);
                    },

                    loginSess: function () {
                        return common.isLogin();
                    },

                    // 判断是否为vip acq用
                    isAcqUser: function (res) {
                        var _this = this;
                        res.data.body.content.forEach(function (item) {
                            if (item.key === 'mediaSources' && item.value.indexOf(dialogObj.memberType) > -1) {
                                _this.isAcqMember = true;
                                _this.setAuthorization();
                                _this.checkNeedResetPasswordCookie();
                            }
                        });
                        if (!this.isAcqMember) {
                            this.signOut();
                            this.dialogStatus = 'login';
                            dialogObj.showDialog();
                        }
                    },

                    //获取用户信息
                    getUserInfo: function () {
                        var _this = this;
                        if (!common.isLogin()) {
                            dialogObj.hideLoading();
                            // 未登录5秒后提示登录
                            _this.loginTimeout=setTimeout(()=>{
                                common.setScroll.unScroll();
                                if(dialogObj.needLottery){
                                    ACQDialog.showLaunchDialog(function () {
                                        _this.dialogStatus = 'login';
                                        // 显示抽奖提示
                                        dialogObj.showDialog();
                                    });
                                }else {
                                    _this.dialogStatus = 'login';
                                    // 显示抽奖提示
                                    dialogObj.showDialog();
                                }
                            },30000)
                            return;
                        }
                        // else{
                        // 已登录
                        // dialogObj.hideLoading();
                        // ACQDialog.showLotteryDialog();
                        // }
                        var info = {
                            globalUserId: getCookie('globalUserId') || '',
                            sess: common.isLogin().session || '',
                        }
                        var _this = this;
                        this.api('member/LookUp', info).then(
                            function (res) {
                                dialogObj.hideLoading();
                                if (res.status == '200') {
                                    _this.isAcqUser(res);
                                }
                            }
                        ).catch(function (error) {
                            console.log(error)
                        })
                        common.setScroll.removeUnScroll();
                    },

                    // 退出登录
                    signOut: function () {
                        delCookie('smarketMember_' + window.cateData.schemaId);
                        gio('clearUserId');
                    },

                    // 登录按钮动作
                    subAction: function () {
                        switch (this.dialogStatus) {
                            case "regist":
                                this.regist();
                                break;
                            case 'login':
                                this.login();
                                break;
                            case 'resetPassword':
                                this.resetPassword();
                                break;
                            case 'forgetPassword':
                                this.forgetSetPassword();
                            default:
                                break;
                        }
                    },
                    // 申请会员资格按钮动作
                    registerBtnAction(){
                        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
                            msg.batchDialog(null, this.purchaseIntentionForm);
                        }else{
                            msg.bargainDialog(null, this.purchaseIntentionForm);
                        }
                        // msg.bargainDialog(null, this.purchaseIntentionForm);
                    },
                    // 文字按钮动作
                    textBtnAction: function () {
                        switch (this.dialogStatus) {
                            case 'regist':
                                common.gotoLogin();
                                break;
                            case 'login':
                                this.forgetPassword();
                                break;
                            case 'resetPassword':
                                this.forgetPassword();
                                break;
                            case 'forgetPassword':
                                this.showLogin();
                            default:
                                break;
                        }
                    },

                    showRegist: function(){
                        this.dialogStatus = 'regist';
                    },

                    // 显示登录界面
                    showLogin: function () {
                        this.dialogStatus = 'login';
                    },

                    regist: function(){
                        var verifyPassword = this.verifyRePassword(this.registForm.formList.password, this.registForm.formList.rePassword);

                        if (!verifyPassword || !this.verifyForm() ||  this.registForm.subBtnDisabled) {
                            console.log('验证不通过')
                            return;
                        }


                        var userName = this.registForm.formList.userName.value;
                        var verifyCode = this.registForm.formList.verifyCode.value;
                        var password = this.registForm.formList.password.value;
                        var ifWish = this.registForm.formList.ifWish.value;

                        this.registForm.subBtnDisabled = true;

                        var info = {
                            'formId': 1430,//表单id
                            'memberSchemaId': '498',//体系id
                            'mobile': userName,//string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
                            'token':  '',//string 第三方登录传 token，token时不需要密码或是动态验证码;
                            'password': (password ? md5(password).toUpperCase() : ''),//string 密码。账号密码的形式必传此项。
                            'checkCode': verifyCode,//string 动态验证码。手机或邮箱动态验证登录传此项
                            'ifWish': '是',
                            'backUrl': window.location.href,
                            'url': window.location.href,
                            'getuserinfo':common.getUrlPara('getuserinfo') || '',
                            'browseInfo': client.browseInfo,
                            'globalUserId': common.getCookie('globalUserId') || '',
                            'OCSESSID': common.getCookie('OCSESSID') || ''
                        };
                        var _this = this;
                        axios.post(solution_host + '/api/account/registerSimple', JSON.stringify(info)).then(function (res) {
                            var data = res.data;
                            if (data.errCode == 0) {
                                _this.setSmarketCookie(data.data.session, data.data.loginId);
                                common.setCookie('OCSESSID', data.data.OCSESSID, 5);
                                gioTrackAction.gio_base('individualRegisterSuccess');
                                layer.msg('注册成功');
                                dialogObj.hideDialog();
                                common.setCookie('light_reg_need_completion', 1);
                                window.location.reload();
                            }else{
                                if(data.msg === '唯一标识已存在' || data.msg === '唯一字段重复：手机'){
                                    layer.msg('您输入的手机号已经注册');
                                }else{
                                    layer.msg(data.msg);
                                }
                            }
                            _this.registForm.subBtnDisabled = false;
                        }).catch(function (error) {
                            console.log(error)
                            _this.registForm.subBtnDisabled = false;
                        })
                    },

                    setSmarketCookie: function(sess, memberId){
                        common.setCookie('smarketMember_'+window.cateData.schemaId, JSON.stringify({
                            session: sess,
                            memberId: memberId
                        }))
                    },

                    // 登录
                    login: function () {
                        if (!this.verifyForm()) {
                            console.log('验证不通过')
                            return;
                        }

                        var userName = this.loginForm.formList.userName.value;
                        var password = this.loginForm.formList.password.value;

                        this.loginForm.subBtnDisabled = true;

                        var info = {
                            'tenantId': '444',//int 租户Id
                            'schemaId': '498',//int 体系Id（选填）
                            'memberFormId': 1386,//表单id
                            'memberSchemaId': '498',//体系id
                            'unique': userName,//string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
                            'token': '',//string 第三方登录传 token，token时不需要密码或是动态验证码 ;
                            'password': (password ? md5(password).toUpperCase() : ''),//string 密码。账号密码的形式必传此项。
                            'checkCode': '',//string 动态验证码。手机或邮箱动态验证登录传此项
                            'loginType': '',//string 登录方式（选填。主要是用于标识用户名，邮箱，手机等.其他标识方式必填）
                            'url': window.location.href,
                            'browseInfo': client.browseInfo,
                            'globalUserId': getCookie('globalUserId') || '',
                        };
                        var _this = this;

                        this.api('member/login', info).then(
                            function (res) {
                                if (res.status == '200') {
                                    if (res.data.body.result == 0) {
                                        if (!res.data.body.content.info.mediaSources || res.data.body.content.info.mediaSources.indexOf(dialogObj.memberType) < 0) {
                                            _this.loginForm.formList.userName.isShowError = true;
                                            _this.loginForm.formList.userName.errorText = '您的账号不是企采会员，请重新登录';
                                        } else {
                                            // 登录成功
                                            setTimeout(function () {
                                                _this.setLoginCookie(res.data.body.content);
                                                _this.needResetPassword(password);
                                            }, 2000);
                                        }
                                    } else {
                                        console.log(res.data.body.content)
                                        _this.loginForm.formList.password.isShowError = true;
                                        _this.loginForm.formList.password.errorText = res.data.body.content;

                                    }

                                }
                                _this.loginForm.subBtnDisabled = false;
                            }
                        ).catch(function (error) {
                            console.log(error)
                        })


                    },

                    // 忘记密码
                    forgetPassword: function () {
                        this.dialogStatus = 'forgetPassword';
                    },

                    // 设置 dell.com 授权链接
                    setAuthorization: function () {
                        var interval = 5; //间隔时间
                        var _this = this;
                        // setUrl();
                        // setInterval(function () {
                        //     setUrl();
                        // }, interval*60*1000);

                        function setUrl(){
                            console.log('进行授权', new Date());
                            document.querySelector('#authorization').setAttribute('src', '');
                            document.querySelector('#authorization').setAttribute('src', _this.authorizationLnk);
                        }

                    },

                    // Dell 授权
                    setAuthorizationUrl: function(authorizationLnk){
                        if(authorizationLnk){
                            // 用于外部修改授权链接
                            this.authorizationLnk = authorizationLnk;
                        }
                        console.log('进行授权', new Date());
                        document.querySelector('#authorization').setAttribute('src', '');
                        document.querySelector('#authorization').setAttribute('src', this.authorizationLnk);
                    },

                    // 设置登录cookie
                    setLoginCookie: function (userInfo) {
                        setCookie('smarketMember_498', JSON.stringify({
                            session: userInfo.sess,
                            memberId: userInfo.memberId,
                            email: userInfo.info.email
                        }), 30);
                        layer.msg('登录成功！');
                        dialogObj.hideDialog();
                    },

                    // 是否需要重设密码
                    needResetPassword: function (password) {
                        if (password === dialogObj.initialPassword) {
                            setCookie('needResetPassword', 1);
                            this.showResetPassword();
                        }
                    },
                    clearneedResetPassword: function () {
                        delCookie('needResetPassword');
                    },

                    // 进入页面检查是否有重设密码的cookie
                    checkNeedResetPasswordCookie: function () {
                        if (getCookie('needResetPassword')) {
                            this.showResetPassword();
                        }
                    },

                    // 重置密码
                    showResetPassword: function () {
                        var _this = this;
                        if (document.querySelector('#login-dialog').style.display === 'block') {
                            setTimeout(function () {
                                show();
                            }, 500)
                        } else {
                            show();
                        }

                        function show() {
                            _this.dialogStatus = 'resetPassword';
                            dialogObj.showDialog();
                        }
                    },

                    resetPassword: function () {
                        var verifyForm = this.verifyForm()
                        var verifyPassword = this.verifyRePassword(this.resetPasswordForm.formList.password, this.resetPasswordForm.formList.rePassword);
                        if (!verifyForm || !verifyPassword) {
                            console.log('验证不通过')
                            return;
                        }
                        var password = this.resetPasswordForm.formList.password.value;

                        var info = {
                            'tenantId': '444',//int 租户Id
                            'oldPwd': md5(dialogObj.initialPassword).toUpperCase(),//int 体系Id（选填）
                            'newPwd': (password ? md5(password).toUpperCase() : ''),//表单id
                            'sess': common.isLogin().session || ''
                        };
                        var _this = this;

                        this.form.subBtnDisabled = true;

                        this.api('api/member/contacts/password/update', info).then(
                            function (res) {
                                console.log(res)
                                if (res.data.body.result == 0) {
                                    layer.msg('重设密码成功');
                                    _this.clearneedResetPassword();
                                    dialogObj.hideDialog();
                                } else {
                                    _this.form.formList.rePassword.isShowError = true;
                                    _this.form.formList.rePassword.errorText = res.data.body.content;
                                }
                                _this.form.subBtnDisabled = false;
                            }
                        ).catch(function (error) {
                            console.log(error)
                        })
                    },

                    forgetSetPassword: function () {
                        var verifyForm = this.verifyForm()
                        var verifyPassword = this.verifyRePassword(this.forgetPasswordForm.formList.password, this.forgetPasswordForm.formList.rePassword);
                        if (!verifyPassword || !verifyForm || !verifyPassword) {
                            console.log('验证不通过')
                            return;
                        }

                        var _this = this;
                        var unique = _this.forgetPasswordForm.formList.userName.value;
                        var checkCode = _this.forgetPasswordForm.formList.verifyCode.value;
                        var password = _this.forgetPasswordForm.formList.password.value;
                        password = (password ? md5(password).toUpperCase() : '');

                        forgetPwd();

                        // 验证码正确性验证
                        function getTonken() {
                            var info = {
                                unique: unique,
                                checkCode: checkCode,
                                formId: 1386,
                                schemaId: 498,
                                action: "all",
                                globalUserId: getCookie('globalUserId') || '',
                            };
                            this.api('member/GetToken', info).then(
                                function (res) {
                                    console.log(res);
                                    if (res.data.body.result === 0) {
                                        layer.msg(res.data.body.desc)
                                    } else {
                                        layer.msg(res.data.body.desc)
                                    }
                                }
                            ).catch(function (error) {
                                layer.msg(error.data.msg)
                            });
                        }


                        // 忘记密码
                        function forgetPwd() {
                            _this.form.subBtnDisabled = true;
                            var info = {
                                checkCode: checkCode,
                                unique: unique,
                                password: password,
                                memberSchemaId: 498,
                                token: "",
                                url: "",
                                referenceUrl: ""
                            };
                            _this.api('member/forgetPwd', info).then(
                                function (res) {
                                    console.log(res);
                                    if (res.data.body.result === 0) {
                                        // layer.msg(res.data.body.desc)
                                        layer.msg("密码重置成功！请登录");
                                        _this.dialogStatus = 'login';
                                    } else {
                                        layer.msg(res.data.body.desc)
                                    }
                                    _this.form.subBtnDisabled = false;
                                }
                            ).catch(function (error) {
                                layer.msg(error.data.msg)
                            });
                        }


                    },

                    sendSms: function () {
                        var userNameVerify = '';
                        var uniqe = '';
                        if (this.dialogStatus == 'regist'){
                            // 注册
                            userNameVerify = this.verify(this.registForm.formList.userName);
                            uniqe = this.registForm.formList.userName.value;
                        }else{
                            userNameVerify = this.verify(this.forgetPasswordForm.formList.userName);
                            uniqe = this.forgetPasswordForm.formList.userName.value;
                        }


                        if (!userNameVerify) {
                            console.log('手机号短信验证失败');
                            return;
                        }
                        // if (!this.formErrorInfo.mobile.status) {
                        //     layer.msg('手机号未填写，或填写不正确');
                        //     return;
                        // }

                        if (this.sendCode.isSending) {
                            return;
                        }


                        this.sendCode.isSending = true;
                        this.sendCode.text = '发送中';

                        var info = {
                            unique: uniqe,
                            memberSchemaId: 498,
                            validTime: 600,
                            intervalTime: 60,
                            action: "register",
                            globalUserId: common.getCookie('globalUserId') || '',
                        };

                        var _this = this;
                        this.api('member/sendCheckCode', info).then(
                            function (res) {
                                console.log(res);
                                _this.sendCode.isSending = false;
                                if (res.data.body.result === 0) {

                                    _this.codeTimer();
                                    // layer.msg(res.data.body.desc)
                                    layer.msg('验证码发送成功！请在10分钟内填写');
                                } else {
                                    if(res.data.body.desc === '唯一标识已存在'){
                                        layer.msg('您输入的手机号已经注册');
                                    }else{
                                        layer.msg(res.data.body.desc);
                                    }
                                }
                            }
                        ).catch(function (error) {
                            _this.sendCode.isSending = false;
                            layer.msg(error.data.msg)
                        });
                    },

                    codeTimer: function () {

                        if (!this.sendCode.isTimer) {
                            this.sendCode.isTimer = true;
                            setTimer();
                        } else {
                            return;
                        }

                        var time = this.sendCode.time;
                        var _this = this;
                        var timer;

                        this.sendCode.text = "等待60秒";

                        function setTimer() {
                            timer = setInterval(function () {
                                if (time > 0) {
                                    time -= 1;
                                    _this.sendCode.text = "等待" + time + "秒";
                                } else {
                                    clearTimer();
                                    _this.sendCode.isTimer = false;
                                }
                            }, 1000);
                        }

                        function clearTimer() {
                            clearInterval(timer)
                        }
                    },

                    // 验证程序
                    verify: function (itemObj) {
                        var flag = true;
                        if (itemObj.isRequired && !itemObj.value) {
                            itemObj.isShowError = true;
                            itemObj.errorText = itemObj.errorTextEmpty ? itemObj.errorTextEmpty : '请输入' + itemObj.lebal;
                            flag = false;
                            return flag;
                        }
                        if (itemObj.reg && itemObj.value) {
                            itemObj.isShowError = !itemObj.reg.test(itemObj.value);
                            if (itemObj.isShowError) {
                                itemObj.isShowError = true;
                                itemObj.errorText = itemObj.errorTextContent ? itemObj.errorTextContent : '您输入的' + itemObj.lebal + '错误';
                                flag = false;
                            }
                        }
                        if (flag) {
                            itemObj.isShowError = false;
                            itemObj.errorText = '';
                        }
                        return flag;
                    },

                    // 验证重新输密码
                    verifyRePassword: function (passwordObj, rePasswordObj) {
                        var flag = true;
                        if (passwordObj.value && rePasswordObj.value) {
                            if (passwordObj.value !== rePasswordObj.value) {
                                rePasswordObj.isShowError = true;
                                rePasswordObj.errorText = rePasswordObj.errorTextContent;
                                flag = false;
                            } else {
                                rePasswordObj.isShowError = false;
                                rePasswordObj.errorText = '';
                            }
                        }
                        return flag;
                    },

                    //验证表单
                    verifyForm: function () {
                        var flag = true;
                        for (var item in this.form.formList) {
                            var itemObj = this.form.formList[item];
                            if(this.verify(itemObj) === false){
                                flag = false;
                            }
                        }
                        return flag;
                    },

                    api: function (url, data) {
                        return axios.post(url, JSON.stringify(data))
                    },
                    // 点击已登录跳转，未登录显示登录弹框，
                    windowOpen(link){
                        var _this=this;
                        if(common.isLogin()){
                            window.open(link)
                        }else{
                            clearTimeout(_this.loginTimeout);
                            dialogObj.showDialog();
                        }
                    },
                    // 登录弹框内的关闭按钮
                    clearLogin(){
                        dialogObj.iconHideDialog();
                    },

                },
                watch: {

                    // 监控表单状态
                    dialogStatus: function (status) {
                        if (status === 'regist') {
                            this.form = this.registForm;
                        }
                        if (status === 'login') {
                            this.form = this.loginForm;
                        }
                        if (status === 'resetPassword') {
                            this.form = this.resetPasswordForm;
                        }
                        if (status === 'forgetPassword') {
                            this.form = this.forgetPasswordForm;
                        }
                    },
                    'loginForm.formList.userName.value': function (value) {
                        this.verify(this.loginForm.formList.userName)
                    },
                    'loginForm.formList.password.value': function (value) {
                        this.verify(this.loginForm.formList.password)
                    },
                    'resetPasswordForm.formList.password.value': function (value) {
                        this.verify(this.resetPasswordForm.formList.password);
                        this.verifyRePassword(this.resetPasswordForm.formList.password, this.resetPasswordForm.formList.rePassword);
                    },
                    'resetPasswordForm.formList.rePassword.value': function (value) {
                        this.verifyRePassword(this.resetPasswordForm.formList.password, this.resetPasswordForm.formList.rePassword);
                    },
                    'forgetPasswordForm.formList.userName.value': function (value) {
                        this.verify(this.forgetPasswordForm.formList.userName);
                    },
                    'forgetPasswordForm.formList.verifyCode.value': function (value) {
                        this.verify(this.forgetPasswordForm.formList.verifyCode);
                    },
                    'forgetPasswordForm.formList.password.value': function (value) {
                        this.verify(this.forgetPasswordForm.formList.password);
                        this.verifyRePassword(this.forgetPasswordForm.formList.password, this.forgetPasswordForm.formList.rePassword);
                    },
                    'forgetPasswordForm.formList.rePassword.value': function (value) {
                        this.verifyRePassword(this.forgetPasswordForm.formList.password, this.forgetPasswordForm.formList.rePassword);
                    },
                }
            })
        },
        showDialog: function () {
            this.dialogBoxDom.style.display = 'block';
            this.maskDom.classList.remove('dialog-mask-ani-fade-out');
            this.maskDom.classList.add('dialog-mask-ani-fade-in');

            this.dialogDom.classList.remove('tr-dialog-ani-to-top');
            this.dialogDom.classList.add('tr-dialog-ani-from-top');

            //禁止后方滚动
            common.setScroll.unScroll();

            //会员有礼入口点击
            gioTrackAction.gio_base('individualRegisterClick',{
                individualRegisterEntrancePageTitle: document.title,
                individualRegisterEntrancePageURL: window.location.href
            });
            //浏览个人会员注册页
            gioTrackAction.gio_base('viewIndividualRegister');
            if (!this.vueObject){
                loginDialog.init();
            }
        },
        hideDialog: function () {
            this.maskDom.classList.remove('dialog-mask-ani-fade-in');
            this.maskDom.classList.add('dialog-mask-ani-fade-out');

            this.dialogDom.classList.remove('tr-dialog-ani-from-top');
            this.dialogDom.classList.add('tr-dialog-ani-to-top');

            var _this = this;
            setTimeout(function () {
                _this.dialogBoxDom.style.display = 'none';
            }, 230);

            //允许后方滚动
            common.setScroll.removeUnScroll();
        },
        // 点击ico 关闭登录表单
        iconHideDialog(){
            this.maskDom.classList.remove('dialog-mask-ani-fade-in');
            this.maskDom.classList.add('dialog-mask-ani-fade-out');

            this.dialogDom.classList.remove('dialog-ani-from-top');
            this.dialogDom.classList.add('dialog-ani-to-top');

            var _this = this;
            setTimeout(function () {
                _this.dialogBoxDom.style.display = 'none';
            }, 230);
            common.setScroll.removeUnScroll();
        },
        showLoading: function(){
            document.querySelector('.login-dialog-loading').style.display = 'block';
            //禁止后方滚动
            common.setScroll.unScroll();
        },
        hideLoading: function(){
            document.querySelector('.login-dialog-loading').style.display = 'none';
            //允许后方滚动
            common.setScroll.removeUnScroll();
        },

        // 退出登录
        signOut: function () {
            delCookie('smarketMember_' + window.cateData.schemaId);
            gio('clearUserId');
            window.location.reload()
        },
        // 抽奖提示的关闭
        hiddenLuckDraw(){
            $('.dialog-container .mask').removeClass('dialog-mask-ani-fade-in');
            $('.dialog-container .dialog-content').removeClass('dialog-ani-from-top');
            $('.dialog-container .mask').addClass('dialog-mask-ani-fade-out');
            $('.dialog-container .dialog-content').addClass('dialog-ani-to-top');
            setTimeout(function () {
                $('.dialog-container').hide();
            },230)
            common.setScroll.removeUnScroll();
        },
        init: function () {
            // this.showLoading();
            this.vueExp();
        }
    };

    window.loginDialog = loginDialog;
});
